var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProblem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4876 2.72422C14.7659 1.06872 16.7593 0.00037082 19.0061 0.00037082C22.8687 0.00037082 26 3.14714 26 7.0287C26 9.05678 25.1403 10.8787 23.7731 12.1613L23.7979 12.1767L13.0283 23L2.4091 12.3278C0.935753 11.0393 0 9.14557 0 7.02833C0 3.14662 3.13115 0 6.99345 0C9.17887 0 11.1233 1.01258 12.4043 2.59148L10.7653 4.23903C10.6579 4.34688 10.6057 4.49815 10.6241 4.64942C10.6422 4.80108 10.729 4.93557 10.8588 5.01429L14.6344 7.30574L11.6812 9.20856C11.548 9.29423 11.4637 9.43894 11.4545 9.59754C11.4455 9.75595 11.5125 9.90954 11.6348 10.0103L13.4462 11.4998L12.4852 16.1512C12.4301 16.4196 12.6014 16.6822 12.8683 16.7381C12.9024 16.7449 12.9362 16.7483 12.969 16.7483C13.1983 16.7483 13.4035 16.5872 13.4523 16.3532L14.4737 11.4073C14.5111 11.2261 14.445 11.0394 14.3028 10.9225L12.7863 9.67524L15.8351 7.71123C15.9787 7.61861 16.0647 7.45827 16.0624 7.28694C16.0603 7.1156 15.97 6.95738 15.8241 6.86882L11.9089 4.49231L12.9819 3.41354L13.4876 2.72375",
    fill: "#A8A7CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblem);
export default __webpack_public_path__ + "static/media/problem.d5db048ceceb269b2817e264a374f153.svg";
export { ForwardRef as ReactComponent };